import React, { Component } from "react";
import { formatAmount } from "../utils/Utils";

export default class CarInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: 0,
    };
  }
  componentDidMount() {
    this.setAmount();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setAmount();
    }
  }
  openModalLiising() {
    this.props.openModalLiising();
  }

  setAmount = () => {
    const { data } = this.props;
    if (data.eripakkumine === "115000.00") {
      this.setState({ amount: 108 });
    } else if (data.eripakkumine === "125000.00") {
      this.setState({ amount: 120 });
    } else if (data.eripakkumine === "130000.00") {
      this.setState({ amount: 120 });
    } else if (data.eripakkumine === "140000.00") {
      this.setState({ amount: 133 });
    } else {
      this.setState({ amount: 100 });
    }
  };

  specialOffers = (komnr) => {
    const notInSpecialOffers = ["PO86289", "PO86290", "PO86291"]; // Example array of komnr values that are not in special offers
    if (!komnr) {
      return null; // Return null or some fallback UI if komnr is undefined
    }
    if (!notInSpecialOffers.includes(komnr)) {
      return (
        <div className="special-offers">
          <span>Pakkumises sisaldub suvepakett väärtusega 13 500 €</span>
          <span>sisaldab:</span>
          <span>5 aastat garantiid (2+3PAW)</span>
          <span>3 aastat regulaarhooldust</span>
          <span>20“ talverataste komplekti</span>
        </div>
      );
    } else {
      return null;
    }
  };

  render() {
    const { data } = this.props;
    //console.log(data);
    return (
      <>
        <div className="specs">
          <h1>Porsche {data.trim} </h1>
          <span>
            {data.mootor} {data.power_kw}kW {data.transmission}
          </span>
          <span> Kom. Nr. {data.komnr} </span>
          <span>Hinnakirjahind: {formatAmount(data.hind)} €</span>
          <span className="specs-price">
            Selle auto hind: {formatAmount(data.eripakkumine)} €
          </span>
          {data.reserved === "jah" || data.reserved === "Jah" ? (
            <span className="reserved">BRONEERITUD</span>
          ) : (
            ""
          )}
          <span>
            Liisingu kuumakse alates: {formatAmount(data.manualkuumakse)} €
          </span>
          <span>
            Kasko kuumakse alates:{" "}
            {data.manual_kasko_kuumakse
              ? data.manual_kasko_kuumakse
              : formatAmount(Math.floor(this.state.amount))}{" "}
            €
          </span>
          <span
            className="text text--underline"
            onClick={() => this.openModalLiising(data.komnr)}
          >
            Liisingu- ja kaskokindlustuse tingimused
          </span>
          {this.specialOffers(data.komnr)}
        </div>
      </>
    );
  }
}
